import { Wrapper, Title, Row, Desc } from './styles';
import { StatusDot } from '../styles';
import { moduleStatuses } from '../enums';

const StatusLegend = () => {
  return (
    <Wrapper>
      <Title>Status Legend:</Title>
      {Object.values(moduleStatuses).map(({ color, desc }, ind) => (
        <Row key={ind}>
          <StatusDot color={color}></StatusDot>
          <Desc>{desc}</Desc>
        </Row>
      ))}
    </Wrapper>
  );
};

export default StatusLegend;
